<div class="vtr-widget-energy-star">
  <div class="d-flex align-items-center">
    <img class="energy-image" src="assets/images/energystar.png" alt="">
    <p class="m-0 pl-4 description" id="dashboard-energyStar-description">{{'device.deviceSettings.power.energyStar.description' | translate}}</p>
  </div>
</div>